import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { ShearingHomeContainer } from '@/components/screens/shearing/shearing-home-container'

export const Route = createFileRoute('/t/$tenant_id/shearing_certificates/')({
  component: ShearingCertificatesPage,
})

// route はレイアウト（サイドバー + メイン領域）だけを組み、データ取得・ミューテーション配線は
// ShearingHomeContainer（components/screens/shearing/）に委譲する
// （routes/t/$tenant_id/index.tsx の MillsheetHomeContainer と同じ分担）
function ShearingCertificatesPage() {
  const { tenant_id: tenantId } = Route.useParams()
  return (
    <div className="flex min-h-screen">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1">
        <ShearingHomeContainer tenantId={tenantId} />
      </main>
    </div>
  )
}
